'use client';

import SectionContainer from '@/components/shared/SectionContainer';
import { Text, Flex } from '@skin-seoul/design-system';
import { getActiveYearEndFlashSaleRotation } from '@skin-seoul/service';
const FLASH_SALE_BANNER_TEXT = 'Upto 50% Off across the selection';
const DEFAULT_BANNER_TEXT = 'Explore Top-Rated Korean Skincare Products';
const DESKTOP_REPEAT_COUNT = 3;
const AnnouncementBar = () => {
  const activeFlashSale = getActiveYearEndFlashSaleRotation();
  const bannerText = activeFlashSale ? FLASH_SALE_BANNER_TEXT : DEFAULT_BANNER_TEXT;
  return <SectionContainer containerInnerProps={{
    background: 'primary.600',
    paddingY: 3,
    gap: 5,
    alignItems: 'center',
    justifyContent: 'center'
  }} data-sentry-element="SectionContainer" data-sentry-component="AnnouncementBar" data-sentry-source-file="AnnouncementBar.tsx">
      <Text textStyle={{
      base: 'paragraph.large.mobile',
      desktop: 'paragraph.large'
    }} fontWeight="regular" color="generic.0" textAlign="center" display={{
      base: 'block',
      desktop: activeFlashSale ? 'none' : 'block'
    }} data-sentry-element="Text" data-sentry-source-file="AnnouncementBar.tsx">
        {bannerText}
      </Text>

      {activeFlashSale && <Flex display={{
      base: 'none',
      desktop: 'flex'
    }} gap={5} alignItems="center" justifyContent="center" width="100%">
          {Array.from({
        length: DESKTOP_REPEAT_COUNT
      }).map((_, index) => <Text key={index} textStyle={{
        base: 'paragraph.large.mobile',
        desktop: 'paragraph.large'
      }} fontWeight="regular" color="generic.0" textAlign="center">
              {bannerText}
            </Text>)}
        </Flex>}
    </SectionContainer>;
};
export default AnnouncementBar;